import React, { useState, Fragment } from "react";
import {
  Grid,
  Paper,
  TextField,
  MenuItem,
  FormControl,
  Select,
  InputLabel,
  Tooltip,
  IconButton,
  Button,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import { useDispatch, useSelector } from "react-redux";
import ConfirmDialog from "../../../Dialog/ConfirmDialog";
import { insertPilAttachment } from "../../../../dataSource/pil";
import { docTypesList } from "../pilAttributeList/pilAttributeList";

const PilStageTwoUploadDetails = ({
  stageTwoFiles,
  setStageTwoFiles,
  stagetwoDialogHandleClose,
  setUpdateFlag,
  pilDetails,
  buildAlert,
  setLockScreenLoadingOpen,
}) => {
  const dispatch = useDispatch();
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [confirmDialogData, setConfirmDialogData] = useState({
    dialogTitle: "",
    dialogContent: "",
    confirmAction: "",
    cancelAction: "",
  });
  const docTypes = docTypesList;
  const deleteItem = (index) => {
    let data = [...stageTwoFiles];
    data.splice(index, 1);
    setStageTwoFiles(data);
  };
  const handleSelect = (event, index) => {
    let data = [...stageTwoFiles];
    data[index]["type"] = event.target.value;
    setStageTwoFiles(data);
  };
  const confirmDialogHandleOpen = (data) => {
    setConfirmDialogData({
      dialogTitle: data.dialogTitle,
      dialogContent: data.dialogContent,
      confirmAction: data.confirmAction,
      cancelAction: data.cancelAction,
    });
    setConfirmDialogOpen(true);
  };
  const confirmDialogHandleClose = () => {
    setConfirmDialogOpen(false);
  };
  const confirmSave = () => {
    confirmDialogHandleOpen({
      dialogTitle: "Save and Upload to Project Information List?",
      dialogContent:
        "Are you sure to save the attachement type and upload to Project Information List?",
      confirmAction: confirmSavePIL,
      cancelAction: confirmDialogHandleClose,
    });
  };
  const confirmSavePIL = async () => {
    confirmDialogHandleClose();
    stagetwoDialogHandleClose();
    setLockScreenLoadingOpen(true);
    try {
      for (const file of stageTwoFiles) {
        try {
          const val = { ...pilDetails };
          await insertPilAttachment(pilDetails.general.pil_seq, file).then(
            (res) => {
              dispatch({
                type: "HANDLE_PIL_VALUE",
                data: { ...pilDetails, val },
              });
            }
          );
        } catch (err) {
          console.log(err);
        }
      }
      buildAlert({
        type: "success",
        title: "Success Alert",
        content:
          "The Project Information List File has been uploaded successfully",
      });
    } catch (err) {
      buildAlert({
        type: "error",
        title: "Error Alert",
        content: `Error:${err}`,
      });
    } finally {
      setUpdateFlag((prev) => !prev);
      setLockScreenLoadingOpen(false);
    }
  };

  return (
    <Fragment>
      <ConfirmDialog
        open={confirmDialogOpen}
        dialogTitle={confirmDialogData.dialogTitle}
        dialogContent={confirmDialogData.dialogContent}
        confirmAction={confirmDialogData.confirmAction}
        cancelAction={confirmDialogData.cancelAction}
      />
      <Paper elevation={2} style={{ height: "90%" }}>
        <Grid style={{ padding: "8px" }} container spacing={1}>
          {stageTwoFiles.length > 0 &&
            stageTwoFiles.map((obj, index) => {
              return (
                <div
                  key={index}
                  style={{
                    margin: "4px",
                    display: "flex",
                    width: "100%",
                    gap: "8px",
                  }}
                >
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      size={"small"}
                      label={"File Name"}
                      value={obj.filename}
                      variant="outlined"
                      disabled
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <TextField
                      fullWidth
                      size={"small"}
                      label={"File Size"}
                      value={
                        obj.filesize
                          ? obj.filesize / 1024 > 1024
                            ? (obj.filesize / 1024 / 1024).toFixed(2) + " MB"
                            : (obj.filesize / 1024).toFixed(2) + " KB"
                          : ""
                      }
                      variant="outlined"
                      disabled
                    />
                  </Grid>
                  <Grid item xs={4}>
                    <FormControl fullWidth size={"small"}>
                      <InputLabel
                        id="demo-simple-select-helper-label"
                        style={{ marginLeft: "16px", marginTop: "-8px" }}
                      >
                        File Types
                      </InputLabel>
                      <Select
                        fullWidth
                        labelId="demo-simple-select-helper-label"
                        id="demo-simple-select-helper"
                        label={"File Types"}
                        onChange={(e) => {
                          handleSelect(e, index);
                        }}
                        value={obj.type}
                        variant="outlined"
                      >
                        {docTypes.map((jobj, i) => {
                          return (
                            <MenuItem key={i} value={jobj.value}>
                              {jobj.label}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={1}>
                    <Tooltip title={"Remove Attachment"}>
                      <IconButton
                        onClick={() => {
                          deleteItem(index);
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </div>
              );
            })}
        </Grid>
      </Paper>
      <Button
        style={{ margin: "8px" }}
        variant="outlined"
        color="primary"
        onClick={confirmSave}
      >
        Save
      </Button>
    </Fragment>
  );
};

export default PilStageTwoUploadDetails;
